import axiosInstance from "../../../../axiosInstance";
import toast from "react-hot-toast";

export const createHotelBooking = (
  FormData,
  bookedBy,
  transactionId,
  hotelInfo,
  setIsLoading,
) => {
  setIsLoading(true);
  axiosInstance
    .post("/booking/create-hotel-booking", {
      FormData,
      bookedBy,
      transactionId,
      hotelInfo,
    })
    .then((response) => {
      toast.success("Your property has been booked successfully!");
      setIsLoading(false);
    })
    .catch((error) => {
      toast.error("Failed to book the property. Please try again.");
    });
};
export const createBanglaQRbooking = (
  FormData,
  bookedBy,
  hotelInfo,
  setIsLoading,
  navigate,
) => {
  setIsLoading(true);
  axiosInstance
    .post("/booking/add", {
      FormData,
      bookedBy,
      hotelInfo,
    })
    .then((response) => {
      toast.success("Your property has been booked successfully!");
      setIsLoading(false);
      navigate(`/hotel/payment/success/${FormData.transactionId}`);
    })
    .catch((error) => {
      toast.error("Failed to book the property. Please try again.");
      navigate(`/tour/booking/failed/${FormData.transactionId}`);
    });
};
